import React from 'react'
import styled from 'styled-components'

export const TodaysDate = styled.span`
  &:hover { 
    background-color: #f5f5f5;
  }
`